import { useEffect, useState } from 'react'
import { FetchAllCaseNotesQuery, useFetchAllCaseNotesLazyQuery } from '../../generated'
import { GRAPHQL_QUERY_POLICY } from '../constants'
import { UseFetchCaseNotesResult } from '../interfaceTypes'

type NoteType = 'billing' | 'staff' | 'client'

interface UseFetchCaseNotesProps {
  caseId: string
  noteTypes: NoteType[]
}

const useFetchCaseNotes = ({ caseId, noteTypes }: UseFetchCaseNotesProps): UseFetchCaseNotesResult => {
  const [notes, setNotes] = useState<FetchAllCaseNotesQuery['fetchAllCaseNotes']['notes']>([])

  const [fetchAllNotes, { loading, refetch }] = useFetchAllCaseNotesLazyQuery({
    ...GRAPHQL_QUERY_POLICY,
    variables: undefined,
    onCompleted(data) {
      if (data) {
        const { fetchAllCaseNotes } = data
        const { notes, response } = fetchAllCaseNotes || {}
        const { status } = response || {}

        if (status === 200) {
          const filteredNotes = notes?.filter(note => noteTypes.includes(note?.noteType?.noteType as NoteType)) || []
          setNotes(filteredNotes)
        }
      }
    }
  })

  useEffect(() => {
    fetchAllNotes({
      variables: {
        notesInput: {
          caseId
        }
      }
    })

    return () => {
      setNotes([])
    }
  }, [caseId, fetchAllNotes, refetch])

  return {
    notes,
    loading,
    refetch
  }
}

export default useFetchCaseNotes
